import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SharedThemeModule } from "@kno2/layout/theme";
import { InputMaskModule } from "@ngneat/input-mask";
import { AgGridModule } from "ag-grid-angular";
import { NgxDropzoneModule } from "ngx-dropzone";
import { NgPipesModule } from "ngx-pipes";
import { FeatureToggleDirective } from "../shared/features/feature-toggle.directive";
import { FileDropzoneComponent } from "../shared/file-dropzone/file-dropzone.component";
import { AlertComponent } from "./alert/alert.component";
import { ActionBarComponent } from "./components/action-bar/action-bar.component";
import { ControlPanelContainerComponent } from "./components/control-panel-layout/control-panel-container.component";
import { ControlPanelComponent } from "./components/control-panel/control-panel.component";
import { ControlPanelItemBodyDirective } from "./components/control-panel/item-body/control-panel-item-body.directive";
import { CustomModalHeaderComponent } from "./components/custom-modal-header/custom-modal-header.component";
import { ConfirmOrDenyComponent } from "./components/dialog/confirm-or-deny/confirm-or-deny.component";
import { ActionsCellRendererComponent } from "./components/grid/actions-cell-renderer/actions-cell-renderer.component";
import { GridComponent } from "./components/grid/grid.component";
import { GridPageSizeSelectComponent } from "./components/grid/page-size-select/grid-page-size-select.component";
import { GridSearchComponent } from "./components/grid/search/grid-search.component";
import { GridTooltipCellRendererComponent } from "./components/grid/tooltip-cell-renderer/grid-tooltip-cell-renderer.component";
import { HtmlTipComponent } from "./components/html-tip/html-tip.component";
import { SplitButtonComponent } from "./components/split-button/split-button.component";
import { TagsInputComponent } from "./components/tags-input/tags-input.component";
import { TaskCardComponent } from "./components/task-card/task-card.component";
import { BottomPaneComponent } from "./components/vertical-split-container/bottom-pane/bottom-pane.component";
import { TopPaneComponent } from "./components/vertical-split-container/top-pane/top-pane.component";
import { VerticalSplitPaneComponent } from "./components/vertical-split-container/vertical-split-pane.component";
import { AppendFileExtensionDirective } from "./directives/append-file-extension/append-file-extension.directive";
import { AutoFocusDirective } from "./directives/autofocus/auto-focus.directive";
import { FileDropzoneOverlayDirective } from "./directives/file-dropzone-overlay.directive";
import { FormControlDirective } from "./directives/form-control/form-control.directive";
import { NgxViewerDirective } from "./directives/ngx-viewer/ngx-viewer.directive";
import { SocialSecurityNumberFormatterDirective } from "./directives/social-security-number-formatter/social-security-number-formatter.directive";
import { TelephoneFormatterDirective } from "./directives/telephone-formatter/telephone-formatter.directive";
import { FileSizePipe } from "./pipes/file-size.pipe";
import { GenderPipe } from "./pipes/gender.pipe";
import { IsoToDatePipe } from "./pipes/iso-to-date.pipe";
import { ResultCountPipe } from "./pipes/result-count.pipe";
import { ResultStatusPipe } from "./pipes/result-status.pipe";
import { TextNormalizationPipe } from "./pipes/text-normalization.pipe";

@NgModule({
    imports: [CommonModule, RouterModule, SharedThemeModule, AgGridModule, FormsModule, ReactiveFormsModule, NgPipesModule, InputMaskModule, NgxDropzoneModule],
    declarations: [
        ConfirmOrDenyComponent,
        FileSizePipe,
        GenderPipe,
        IsoToDatePipe,
        ResultCountPipe,
        ResultStatusPipe,
        TextNormalizationPipe,
        TaskCardComponent,
        ActionsCellRendererComponent,
        GridComponent,
        BottomPaneComponent,
        TopPaneComponent,
        VerticalSplitPaneComponent,
        FormControlDirective,
        HtmlTipComponent,
        FeatureToggleDirective,
        GridPageSizeSelectComponent,
        GridSearchComponent,
        TagsInputComponent,
        AppendFileExtensionDirective,
        TelephoneFormatterDirective,
        AlertComponent,
        GridTooltipCellRendererComponent,
        SplitButtonComponent,
        AutoFocusDirective,
        CustomModalHeaderComponent,
        FileDropzoneComponent,
        ControlPanelContainerComponent,
        ControlPanelItemBodyDirective,
        ControlPanelComponent,
        SocialSecurityNumberFormatterDirective,
        ActionBarComponent,
        FileDropzoneOverlayDirective,
        NgxViewerDirective
    ],
    exports: [
        NgPipesModule,
        CommonModule,
        ConfirmOrDenyComponent,
        SharedThemeModule,
        FileSizePipe,
        GenderPipe,
        IsoToDatePipe,
        ResultCountPipe,
        ResultStatusPipe,
        TextNormalizationPipe,
        TaskCardComponent,
        GridComponent,
        ActionsCellRendererComponent,
        BottomPaneComponent,
        TopPaneComponent,
        VerticalSplitPaneComponent,
        FormControlDirective,
        HtmlTipComponent,
        FeatureToggleDirective,
        GridPageSizeSelectComponent,
        GridSearchComponent,
        TagsInputComponent,
        AppendFileExtensionDirective,
        TelephoneFormatterDirective,
        NgxViewerDirective,
        AlertComponent,
        InputMaskModule,
        SplitButtonComponent,
        AutoFocusDirective,
        CustomModalHeaderComponent,
        FileDropzoneComponent,
        ControlPanelContainerComponent,
        ControlPanelComponent,
        SocialSecurityNumberFormatterDirective,
        ActionBarComponent,
        FileDropzoneOverlayDirective
    ]
})
export class SharedUiCommonModule {}
